import { Trans } from "@lingui/macro";
import { MediaList } from "@src/utils/components/dropzone";
import { observer } from "mobx-react-lite";
import { useStore } from "../../store";
import { Loading } from "./Loading";

export const ContractorFiles = observer(function ContractorFiles() {
  const store = useStore();

  if (store.contractLoading) {
    return <Loading />;
  }

  if (store.contract) {
    return (
      <MediaList
        showPreviewIfOnlyOne
        showDelete={false}
        files={store.contractFiles}
      />
    );
  }

  return (
    <Trans>
      Please choose Contractor first, then one of Contract to display document
      preview.
    </Trans>
  );
});
